import type { SVGProps } from 'react';
import * as React from 'react';

const ArrowsPointingOutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/arrows-pointing-out">
      <g id="Icon">
        <path
          d="M15.9364 9.33642L19.8 5.47282V8.70002C19.8 9.19708 20.203 9.60002 20.7 9.60002C21.1971 9.60002 21.6 9.19708 21.6 8.70002V3.30002C21.6 2.80297 21.1971 2.40002 20.7 2.40002H15.3C14.803 2.40002 14.4 2.80297 14.4 3.30002C14.4 3.79708 14.803 4.20002 15.3 4.20002H18.5272L14.6636 8.06363C14.3122 8.4151 14.3122 8.98495 14.6636 9.33642C15.0151 9.68789 15.5849 9.68789 15.9364 9.33642Z"
          fill="currentColor"
        />
        <path
          d="M2.40002 20.7V15.3C2.40002 14.803 2.80297 14.4 3.30002 14.4C3.79708 14.4 4.20002 14.803 4.20002 15.3V18.5272L8.06363 14.6636C8.4151 14.3122 8.98495 14.3122 9.33642 14.6636C9.68789 15.0151 9.68789 15.5849 9.33642 15.9364L5.47282 19.8H8.70002C9.19708 19.8 9.60002 20.203 9.60002 20.7C9.60002 21.1971 9.19708 21.6 8.70002 21.6H3.30002C3.06969 21.6 2.83936 21.5122 2.66363 21.3364C2.57734 21.2501 2.51224 21.1507 2.46832 21.0445C2.42431 20.9384 2.40002 20.8221 2.40002 20.7Z"
          fill="currentColor"
        />
        <path
          d="M14.6636 15.9364L18.5272 19.8H15.3C14.803 19.8 14.4 20.203 14.4 20.7C14.4 21.1971 14.803 21.6 15.3 21.6H20.7C20.9304 21.6 21.1607 21.5122 21.3364 21.3364C21.4227 21.2501 21.4878 21.1507 21.5317 21.0445C21.5757 20.9384 21.6 20.8221 21.6 20.7V15.3C21.6 14.803 21.1971 14.4 20.7 14.4C20.203 14.4 19.8 14.803 19.8 15.3V18.5272L15.9364 14.6636C15.5849 14.3122 15.0151 14.3122 14.6636 14.6636C14.3122 15.0151 14.3122 15.5849 14.6636 15.9364Z"
          fill="currentColor"
        />
        <path
          d="M4.20002 5.47282L8.06363 9.33642C8.4151 9.68789 8.98495 9.68789 9.33642 9.33642C9.68789 8.98495 9.68789 8.4151 9.33642 8.06363L5.47282 4.20002H8.70002C9.19708 4.20002 9.60002 3.79708 9.60002 3.30002C9.60002 2.80297 9.19708 2.40002 8.70002 2.40002H3.30002C2.80297 2.40002 2.40002 2.80297 2.40002 3.30002V8.70002C2.40002 9.19708 2.80297 9.60002 3.30002 9.60002C3.79708 9.60002 4.20002 9.19708 4.20002 8.70002V5.47282Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default ArrowsPointingOutIcon;
